import React from 'react';

const Hand: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="59" height="61" viewBox="0 0 59 61" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.0712 10.3466C10.0253 10.3466 8.44434 12.0205 8.44434 14.0664V41.407H15.698V14.0664C15.698 12.0205 14.117 10.3466 12.0712 10.3466Z"
        fill="#FFDD67"
      />
      <path
        d="M31.6006 41.4071H39.3192V10.2537C39.3192 8.20777 37.5523 6.44086 35.5064 6.44086C33.3675 6.44086 31.6936 8.20777 31.6936 10.3467C31.6006 10.3467 31.6006 41.4071 31.6006 41.4071Z"
        fill="#FFDD67"
      />
      <path
        d="M35.1791 6C34.873 6 34.6689 6 34.4648 6.09309C36.4036 6.37234 37.9342 7.95479 37.9342 9.81649V41H39.4648V9.81649C39.3628 7.67553 37.424 6 35.1791 6Z"
        fill="#EBA352"
      />
      <path
        d="M15.5579 41H23.4648V9.90909C23.4648 7.72727 21.6974 6 19.4648 6C17.2323 6 15.4648 7.72727 15.4648 9.90909L15.5579 41Z"
        fill="#FFDD67"
      />
      <path
        d="M20.0248 6C19.7848 6 19.6248 6 19.4648 6.08993C21.0648 6.44964 22.2648 7.97842 22.2648 9.95683V29.1115L23.4648 31V9.86691C23.4648 7.70863 21.9448 6 20.0248 6Z"
        fill="#EBA352"
      />
      <path
        d="M23.5579 39H31.4648V7.02078C31.4648 4.77662 29.6974 3 27.4648 3C25.2323 3 23.4648 4.77662 23.4648 7.02078L23.5579 39Z"
        fill="#FFDD67"
      />
      <path
        d="M27.6021 3C27.3232 3 27.1372 3 26.9512 3.093C28.8111 3.46498 30.206 5.0459 30.206 7.09179V29.5036L31.6009 31.4565V6.9988C31.6009 4.76691 29.834 3 27.6021 3Z"
        fill="#EBA352"
      />
      <path
        d="M12.0719 10.3466C11.7929 10.3466 11.6069 10.3466 11.4209 10.4396C13.0948 10.8116 14.3967 12.2995 14.3967 14.0664V30.3406L15.7917 32.2935V14.0664C15.6987 12.0205 14.1178 10.3466 12.0719 10.3466Z"
        fill="#EBA352"
      />
      <path
        d="M56.2952 28.8153C54.7829 26.0077 50.057 26.1889 45.2366 31.2605C41.834 34.7926 41.1724 35.9699 37.7698 35.8793V32.1662C37.7698 32.1662 7.80776 32.2567 7.80776 34.5209C7.80776 34.5209 6.39 44.5736 9.32004 50.9131C13.6678 60.3319 34.0836 61.7809 42.6847 46.4754C47.6941 37.4189 57.902 31.8039 56.2952 28.8153Z"
        fill="#FFDD67"
      />
      <path
        d="M56.1512 28.3877C55.8722 27.8297 55.5002 27.4577 55.0352 27.0858C55.1282 27.1787 55.2212 27.2717 55.2212 27.4577C56.8021 30.6196 52.0594 33.8744 48.7116 37.2222C46.0147 39.9191 43.4108 42.709 42.1089 45.9638C36.1572 60.1921 18.8601 60.1921 11.6064 53.6824C18.2091 61.122 36.7152 61.773 43.0388 46.8937C44.4338 43.6389 46.8516 40.942 49.6415 38.1522C52.9893 34.7114 57.7321 31.4565 56.1512 28.3877Z"
        fill="#EBA352"
      />
      <path
        d="M38.8544 35.6413C33.3677 33.6884 22.0223 37.5012 23.5102 48.3817C23.5102 38.2452 32.7168 35.7343 37.7385 35.7343C38.3895 35.6413 38.8544 35.6413 38.8544 35.6413Z"
        fill="#EBA352"
      />
    </svg>
  );
};

export default Hand;
